// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__3mnk_","container":"News_container__erS4g"};